module.exports = __webpack_public_path__ + "static/media/ios-checkmark-circle.2199536b.svg";